import React from 'react'

export const Error404 = () => <React.Fragment>
	<h1>Hier zirpen nur Grillen</h1>
	<p style={{textAlign: 'center'}}>Wir haben einige von ihnen auf die Suche nach ihrer vermissten Seite geschickt.</p>
	<p style={{textAlign: 'center'}}>Sie sind sicher bald zurück.</p>
</React.Fragment>

export default Error404



// WEBPACK FOOTER //
// ./src/components/error404.jsx